import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import ContactFields from '@/components/common/ContactFields.vue';
import { Contact } from '@/models/contact.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactField',
  props: {
  modelValue: {
    type: Array as PropType<Contact[]>,
    required: true,
    default: () => [],
  },
  disabled: {
    type: Boolean,
  },
},
  emits: ['update:modelValue', 'change', 'remove'],
  setup(__props, { emit: __emit }) {

const props = __props;

const contacts = ref<Contact[]>([...(props.modelValue || [])]);

const emit = __emit;

function update(v: Contact[]) {
  emit('update:modelValue', v);
  emit('change', v);
}

function addContact() {
  contacts.value = [
    ...(contacts.value || []),
    {
      id: -1,
      firstName: '',
      lastName: '',
      language: 'nl',
      email: '',
      phone: '',
      url: '',
      main: false,
    },
  ];
}

function removeContact(index: number) {
  const item = contacts.value[index];

  if (item.id !== -1) {
    emit('remove', item);
  }

  contacts.value.splice(index, 1);
}

watch(
  () => props.modelValue,
  () => {
    contacts.value = [...(props.modelValue || [])];
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('initiative.edit.contacts', { count: contacts.value.length })), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts.value || [], (a, index) => {
      return (_openBlock(), _createBlock(ContactFields, {
        label: `${_ctx.$t('initiative.edit.contact')} ${index + 1}`,
        removable: "",
        onRemove: ($event: any) => (removeContact(index)),
        key: index,
        modelValue: contacts.value[index],
        "onUpdate:modelValue": [($event: any) => ((contacts.value[index]) = $event), 
      (v) =>
        update([...contacts.value.slice(0, index), v, ...contacts.value.slice(index + 1)])
    ],
        disabled: __props.disabled
      }, null, 8, ["label", "onRemove", "modelValue", "onUpdate:modelValue", "disabled"]))
    }), 128)),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_v_btn, {
          key: 0,
          onClick: addContact
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('initiative.edit.addContact')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1))
  ], 64))
}
}

})